// extracted by css-extract-rspack-plugin
export default {"results":"InsightsAiResults_results__AgRYD","scalarResult":"InsightsAiResults_scalarResult__HOhRA"};